import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { loadUnidade } from 'src/app/store/unidade/unidade.actions';
import { selectUnidadeLista } from 'src/app/store/unidade/unidade.selectors';
import { Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'service-report-filter-menu',
  templateUrl: './service-report-filter-menu.component.html',
  styleUrls: ['./service-report-filter-menu.component.scss']
})
export class ServiceReportFilterMenuComponent {

  @Output() filterEvent = new EventEmitter();
  @Input() filterBySplit: boolean = false

  dataAtual = new Date();
  anoAtual = Number(this.datePipe.transform(this.dataAtual, 'yyyy'));
  monthOptions: Array<{ label: string, value: string }> = []

  unitsFromAPI$ = this.store.select(selectUnidadeLista);

  form = this.fb.group({
    selectButtonFrequency: ['mes a mes', Validators.required],
    dropdownPeriod: ['', Validators.required],
    dropdownUnit: ['', Validators.required],
    dropdownAddress: ['', Validators.required]
  })

  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.monthOptions = this.monthToMonthOptions

    this.store.dispatch(loadUnidade());
  }

  addNewFilterEvent() {

    if (this.form.valid) {

      if (this.filterBySplit) {
        let filterOptions = {
          frequency: this.form.value.selectButtonFrequency,
          period: this.form.value.dropdownPeriod,
          unit: this.form.value.dropdownUnit,
          address: this.form.value.dropdownAddress
        }

        this.filterEvent.emit(filterOptions);

      } else {
        let filterOptions = {
          frequency: this.form.value.selectButtonFrequency,
          period: this.form.value.dropdownPeriod,
          unit: this.form.value.dropdownUnit
        }

        this.filterEvent.emit(filterOptions);
      }


      //console.log('filter Options: ', filterOptions)
    } else {
      //console.log('form invalido')
    }

  }

  onOptionClick(event: any) {

    this.form.controls.dropdownPeriod.setValue('')

    switch (event.option.value) {
      case 'mes a mes':
        this.monthOptions = this.monthToMonthOptions
        break;
      case 'trimestral':
        this.monthOptions = this.quarterlyOptions
        break;
      case 'anual':
        this.monthOptions = this.yearlyOptions
        break;
    }

    this.addNewFilterEvent()

  }

  monthToMonthOptions = [
    { label: `01 - 31 Janeiro ${this.anoAtual}`, value: 'Janeiro' },
    { label: `01 - 28 Fevereiro ${this.anoAtual}`, value: 'Fevereiro' },
    { label: `01 - 31 Março ${this.anoAtual}`, value: 'Março' },
    { label: `01 - 30 Abril ${this.anoAtual}`, value: 'Abril' },
    { label: `01 - 31 Maio ${this.anoAtual}`, value: 'Maio' },
    { label: `01 - 30 Junho ${this.anoAtual}`, value: 'Junho' },
    { label: `01 - 31 Julho ${this.anoAtual}`, value: 'Julho' },
    { label: `01 - 31 Agosto ${this.anoAtual}`, value: 'Agosto' },
    { label: `01 - 30 Setembro ${this.anoAtual}`, value: 'Setembro' },
    { label: `01 - 31 Outubro ${this.anoAtual}`, value: 'Outubro' },
    { label: `01 - 30 Novembro ${this.anoAtual}`, value: 'Novembro' },
    { label: `01 - 31 Dezembro ${this.anoAtual}`, value: 'Dezembro' },
  ]

  quarterlyOptions = [
    { label: 'Janeiro - Março', value: 'Janeiro - Março' },
    { label: 'Abril - Junho', value: 'Abril - Junho' },
    { label: 'Julho - Setembro', value: 'Julho - Setembro' },
    { label: 'Outubro - Dezembro', value: 'Outubro - Dezembro' }
  ]

  yearlyOptions = [
    { label: `${this.anoAtual}`, value: `${this.anoAtual}` },
    { label: `${this.anoAtual! - 1}`, value: `${this.anoAtual! - 1}` },
    { label: `${this.anoAtual! - 2}`, value: `${this.anoAtual! - 2}` },
    { label: `${this.anoAtual! - 3}`, value: `${this.anoAtual! - 3}` },
    { label: `${this.anoAtual! - 4}`, value: `${this.anoAtual! - 4}` },
  ]
}
